const STATUS_CFG = {
  pending: { label: "Pending", color: "var(--amber)" },
  reviewed: { label: "Reviewed", color: "var(--blue)" },
  accepted: { label: "Accepted", color: "var(--green)" },
  rejected: { label: "Rejected", color: "var(--red)" },
};

export { STATUS_CFG };
